import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'

import PrimaryButton from '../../common/buttons/PrimaryButton';
import SecondaryButton from '../../common/buttons/SecondaryButton';
import useStyles from './styles';


const ButtonsFooter = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation(['translation'])
  const classes = useStyles();
  return (
    <div className={classes.buttonsFooter}>
      <SecondaryButton type="button" onClick={onCancel} className={classes.button}>
        {t('CAMPAIGN.QUESTIONNAIRE.QUESTION_CANCEL_BUTTON')}
      </SecondaryButton>
      <PrimaryButton type="button" onClick={onConfirm} className={classes.button}>
        {t('CAMPAIGN.QUESTIONNAIRE.QUESTION_SAVE_BUTTON')}
      </PrimaryButton>
    </div>
  );
};


ButtonsFooter.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ButtonsFooter;
